import React from 'react';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '../../ui/card';
import { Input } from '../../ui/input';
import { AlertCircle, BarChart3, Facebook, Code } from 'lucide-react';

const validateFacebookPixel = (id) => !id || /^\d{15,16}$/.test(id);
const validateGoogleAnalytics = (id) => !id || /^(G-[A-Z0-9]+|UA-\d+-\d+)$/.test(id);
const validateGTM = (id) => !id || /^GTM-[A-Z0-9]+$/.test(id);

const SeoTrackingSection = ({ seoData, setSeoData }) => {
  const handle = (field) => (e) => setSeoData(prev => ({ ...prev, [field]: e.target.value }));

  return (
    <>
      <Card>
        <CardHeader>
          <CardTitle className="flex items-center gap-2">
            <Facebook className="h-5 w-5 text-blue-600" />
            Facebook Pixel
          </CardTitle>
          <CardDescription>
            Pour suivre les conversions de vos publicités Facebook/Meta Ads
          </CardDescription>
        </CardHeader>
        <CardContent className="space-y-4">
          <Input
            value={seoData.facebook_pixel_id}
            onChange={handle('facebook_pixel_id')}
            placeholder="123456789012345"
            data-testid="facebook-pixel-input"
          />
          {seoData.facebook_pixel_id && !validateFacebookPixel(seoData.facebook_pixel_id) && (
            <p className="text-xs text-red-500 flex items-center gap-1">
              <AlertCircle className="h-3 w-3" />
              Format invalide. Le Pixel ID doit contenir 15-16 chiffres.
            </p>
          )}
          <div className="p-3 bg-blue-50 border border-blue-200 rounded-lg text-sm">
            <p className="text-blue-800">
              Trouvez votre Pixel ID dans le{' '}
              <a
                href="https://business.facebook.com/events_manager"
                target="_blank"
                rel="noopener noreferrer"
                className="underline font-medium"
              >
                Meta Events Manager
              </a>
            </p>
          </div>
        </CardContent>
      </Card>

      <Card>
        <CardHeader>
          <CardTitle className="flex items-center gap-2">
            <BarChart3 className="h-5 w-5 text-orange-500" />
            Google Analytics (GA4)
          </CardTitle>
          <CardDescription>
            Pour analyser le trafic et le comportement des visiteurs sur votre site
          </CardDescription>
        </CardHeader>
        <CardContent className="space-y-4">
          <Input
            value={seoData.google_analytics_id}
            onChange={handle('google_analytics_id')}
            placeholder="G-XXXXXXXXXX"
            data-testid="google-analytics-input"
          />
          {seoData.google_analytics_id && !validateGoogleAnalytics(seoData.google_analytics_id) && (
            <p className="text-xs text-red-500 flex items-center gap-1">
              <AlertCircle className="h-3 w-3" />
              Format invalide. Ex: G-XXXXXXX ou UA-XXXXX-X
            </p>
          )}
          <div className="p-3 bg-orange-50 border border-orange-200 rounded-lg text-sm">
            <p className="text-orange-800">
              Trouvez votre ID dans{' '}
              <a
                href="https://analytics.google.com/"
                target="_blank"
                rel="noopener noreferrer"
                className="underline font-medium"
              >
                Google Analytics
              </a>
              {' '}&gt; Admin &gt; Flux de données
            </p>
          </div>
        </CardContent>
      </Card>

      <Card>
        <CardHeader>
          <CardTitle className="flex items-center gap-2">
            <Code className="h-5 w-5 text-blue-500" />
            Google Tag Manager
          </CardTitle>
          <CardDescription>
            Pour gérer tous vos tags de suivi depuis une interface centralisée
          </CardDescription>
        </CardHeader>
        <CardContent className="space-y-4">
          <Input
            value={seoData.google_tag_manager_id}
            onChange={handle('google_tag_manager_id')}
            placeholder="GTM-XXXXXXX"
            data-testid="gtm-input"
          />
          {seoData.google_tag_manager_id && !validateGTM(seoData.google_tag_manager_id) && (
            <p className="text-xs text-red-500 flex items-center gap-1">
              <AlertCircle className="h-3 w-3" />
              Format invalide. Ex: GTM-XXXXXXX
            </p>
          )}
          <div className="p-3 bg-blue-50 border border-blue-200 rounded-lg text-sm">
            <p className="text-blue-800">
              Trouvez votre ID dans{' '}
              <a
                href="https://tagmanager.google.com/"
                target="_blank"
                rel="noopener noreferrer"
                className="underline font-medium"
              >
                Google Tag Manager
              </a>
              {' '}&gt; Admin &gt; ID du conteneur
            </p>
          </div>
        </CardContent>
      </Card>
    </>
  );
};

export default SeoTrackingSection;
